import type { Vacation } from "../types";

/** Gilt die Ferie für diesen Schüler? appliesToAll heißt alle Schüler, bei Ferien für alle
 *  Zeiträume abzüglich derer, die im Zeitraum einzeln herausgenommen wurden. Raster und
 *  Export fragen hier, damit beide dasselbe zeigen. Gegenstück im Backend:
 *  vacationAppliesTo in services/planning-vacations.ts (Auto-Planung). */
export function vacationAppliesTo(v: Vacation, studentId: number): boolean {
  if (v.appliesToAll) return !(v.shared?.excludedStudentIds ?? []).includes(+studentId);
  return +(v.studentId ?? 0) === +studentId;
}
